import { Response } from "@/types/response/Response";
import ApiUtils from "../../lib/ApiUtils";
import { createApi } from "@reduxjs/toolkit/query/react";
import { PageDTO } from "@/types/response/PageDTO";
import { MessageStatusDTO } from "@/types/message/MessageStatusDTO";
import { MessageTypeDTO } from "@/types/message/MessageTypeDTO";
import { VerificationMessageDetailsDTO } from "@/types/verificationmessage/VerificationMessageDetailsDTO";
import { VerificationMessageFilterDTO } from "@/types/verificationmessage/VerificationMessageFilterDTO";

export const verificationMessageApiV1 = createApi({
  reducerPath: "_verification_message",
  baseQuery: ApiUtils.apiQuery("/v1"),
  tagTypes: ["_verification_messages", "_messages_status_list", "_messages_type_list"],
  endpoints: (builder) => ({
    getVerificationMessages: builder.query<
      Response<PageDTO<VerificationMessageDetailsDTO>>,
      Partial<VerificationMessageFilterDTO>
    >({
      query: (params) => ({
        url: "messages/verification",
        method: "GET",
        params: params,
      }),
      providesTags: ["_verification_messages"],
    }),
    getMessageStatusList: builder.query<
      Response<MessageStatusDTO[]>,
      Partial<void>
    >({
      query: () => "/messages/status-list",
      providesTags: ["_messages_status_list"],
    }),
    getMessageTypeList: builder.query<
      Response<MessageTypeDTO[]>,
      Partial<void>
    >({
      query: () => "/messages/type-list",
      providesTags: ["_messages_type_list"],
    }),
  }),
});

export const {
  useLazyGetVerificationMessagesQuery,
  useGetMessageTypeListQuery,
  useGetMessageStatusListQuery,
} = verificationMessageApiV1;
